import { cx } from '@vizit/theme';
import { OverlayArrow, Tooltip, type TooltipProps, TooltipTrigger } from 'react-aria-components';
import { composeTailwindRenderProps } from '../../utils';

const _TooltipTrigger = TooltipTrigger;

export interface _TooltipProps extends Omit<TooltipProps, 'children'> {
  children: React.ReactNode;
  arrowClassName?: string;
}

function _Tooltip(props: _TooltipProps) {
  const { arrowClassName, children, className, offset = 10, ...other } = props;

  return (
    <Tooltip
      className={composeTailwindRenderProps(
        className,
        cx(
          'group z-50 rounded-none bg-gray-dark-975 p-4 text-xs text-white shadow-md',

          /* Enter animation */
          'animate-in fade-in-0',

          /* Exit animation */
          'data-[exiting]:animate-out data-[exiting]:fade-out-0 data-[exiting]:zoom-out-95',

          /* Placement animations */
          'data-[placement=bottom]:slide-in-from-top-2',
          'data-[placement=left]:slide-in-from-right-2',
          'data-[placement=right]:slide-in-from-left-2',
          'data-[placement=top]:slide-in-from-bottom-2',
        ),
      )}
      offset={offset}
      placement="top"
      {...other}
    >
      <OverlayArrow>
        <svg
          className={cx(
            'h-4 w-4 fill-gray-dark-975 stroke-gray-dark-975',

            /* Placement rotations */
            'group-placement-left:-rotate-90',
            'group-placement-right:rotate-90',
            'group-placement-bottom:rotate-180',

            /* High contrast mode */
            'forced-colors:fill-white forced-colors:stroke-white',

            arrowClassName,
          )}
          viewBox="0 0 8 8"
        >
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      {children}
    </Tooltip>
  );
}

export { _Tooltip as Tooltip, _TooltipTrigger as TooltipTrigger };
